import React, { Component } from "react";
import LdsButton from "../components/LdsButton";

class NotFound extends Component {
    render() {
        return (
            <main className="not-found">
                <section className="section">
                    <div className="container bg">
                        <p className="xl-text blue trade b text-center m-0">
                            OOPS!
                        </p>
                        <p className="h4 text-center mb-3 black">404: Error</p>
                        <h1 className="text-center text-uppercase b black">
                            that page can’t be found
                        </h1>
                        <p className="text-center h2 black text-uppercase mt-5 b">
                            No worries
                        </p>
                        <p className="text-center h2 black text-uppercase mb-5 b">
                            we can fix this
                        </p>
                        <div className="row justify-content-center">
                            <div className="col-md-5" style={{ textAlign: "center" }}>
                                <LdsButton classes="orange-button mt-100 next ms-5" onClick={function navClick() { window.open("/", "_self") }}>
                                    Go to Homepage
                                </LdsButton>

                                <LdsButton classes="orange-button mt-100 ms-5 next" onClick={function navClick() { window.open("/module-1/overview", "_self") }}>
                                    Start your training
                                </LdsButton>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

export default NotFound; 